module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.544c3513.woff2";